import { render, staticRenderFns } from "./RecipeListKeywordCloud.vue?vue&type=template&id=5248f968&scoped=true&"
import script from "./RecipeListKeywordCloud.vue?vue&type=script&lang=js&"
export * from "./RecipeListKeywordCloud.vue?vue&type=script&lang=js&"
import style0 from "./RecipeListKeywordCloud.vue?vue&type=style&index=0&id=5248f968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5248f968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5248f968')) {
      api.createRecord('5248f968', component.options)
    } else {
      api.reload('5248f968', component.options)
    }
    module.hot.accept("./RecipeListKeywordCloud.vue?vue&type=template&id=5248f968&scoped=true&", function () {
      api.rerender('5248f968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecipeListKeywordCloud.vue"
export default component.exports